import "./hidden.css";

const HiddenAltText = ({ children }: { children: string | undefined }) => {
	if (!children) return null;
	return <span className="visually-hidden">{children}</span>;
};
export default HiddenAltText;
